import { useEffect, useState } from 'react';
import { fetchAvailableSeatOptionsAndOwnedProducts } from './requestSeatApi';
export const useRequestSeatModalData = () => {
  const [requestSeatModalData, setRequestSeatModalData] = useState({
    availableSeatOptions: [],
    defaultSeat: undefined,
    isLoading: true,
    ownedHubsAndSuiteApiNames: []
  });
  useEffect(() => {
    fetchAvailableSeatOptionsAndOwnedProducts().then(({
      seatOptions,
      ownedHubsAndSuiteApiNames
    }) => {
      setRequestSeatModalData({
        isLoading: false,
        availableSeatOptions: seatOptions,
        defaultSeat: seatOptions.length > 0 ? seatOptions[0].value : null,
        ownedHubsAndSuiteApiNames
      });
    }).catch(() => {
      setRequestSeatModalData({
        availableSeatOptions: [],
        defaultSeat: null,
        isLoading: false,
        ownedHubsAndSuiteApiNames: []
      });
    });
  }, []);
  return requestSeatModalData;
};